import { Stack } from "@mui/material";
import { toast } from "react-hot-toast";
import { suppliersApi } from "src/api/suppliers";
import { slice } from "src/slices/suppliers";

const getSuppliers = () => async (dispatch) => {
  try {
    dispatch(slice.actions.setSuppliersLoading(true));

    const response = await suppliersApi.getSuppliers();

    dispatch(slice.actions.setSuppliers(response));
    dispatch(slice.actions.setSuppliersLoading(false));
  } catch (err) {
    console.log(err);
    dispatch(slice.actions.setSuppliersLoading(false));
  }
};

const getSupplierDetails = (supplierId) => async (dispatch) => {
  try {
    dispatch(slice.actions.setSupplierDetailsLoading(true));

    const response = await suppliersApi.getSupplierDetails(supplierId);

    dispatch(slice.actions.setSupplierDetails(response));
    dispatch(slice.actions.setSupplierDetailsLoading(false));
  } catch (err) {
    console.log(err);
    dispatch(slice.actions.setSupplierDetailsLoading(false));
  }
};

const alterPortalAccess = (supplierId) => async (dispatch) => {
  try {
    dispatch(slice.actions.setSubmitPortalAccessLoading(true));

    await suppliersApi.alterPortalAccess(supplierId);

    dispatch(slice.actions.setSubmitPortalAccessLoading(false));

    // Refresh supplier details
    dispatch(slice.actions.setSupplierDetailsLoading(true));
    const response = await suppliersApi.getSupplierDetails(supplierId);
    dispatch(slice.actions.setSupplierDetails(response));
    dispatch(slice.actions.setSupplierDetailsLoading(false));
    return true;
  } catch (err) {
    console.log(err?.response?.data?.error?.message);
    dispatch(slice.actions.setSubmitPortalAccessLoading(false));
    dispatch(slice.actions.setSubmitPortalAccessError(true));

    toast(
      <div>
        <Stack>{err?.response?.data?.error?.message}</Stack>
      </div>,
      {
        duration: 5000,
        style: {
          fontFamily: "tmwCustomFont",
          letterSpacing: 1,
          fontSize: 12,
          backgroundColor: "white",
          color: "black",
          border: "1px solid #E6E6E6",
        },
      }
    );
    return false;
  }
};

export const thunks = {
  getSuppliers,
  getSupplierDetails,
  alterPortalAccess,
};
